import "./index.scss";
// import Background from "../../../../features/Background.jpeg";
import Background from "../../../../static/images/Background.jpeg";

const ColoredLine = ({ color }: any) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 3,
    }}
  />
);

export default function LeaderBoard() {
  return (
    <div
      style={{
        backgroundImage: "url(" + Background + ")",
        backgroundSize: "cover",
        minHeight: "100vh",
        color: "#f5f5f5",
        backgroundAttachment: "fixed",
      }}
    >
      <h1>LEADERBOARD</h1>
      <br />
      <br />
      <div className="container1">
        <div className="container2">
          <p className="text">1. Ritwika</p>
          <div className="spacing"></div>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
        </div>
        <ColoredLine color="#54121E" />
        <br />
        <p className="text1">Score: 2592 points</p>
        <div></div>
      </div>
      <br />
      <div className="container1">
        <div className="container2">
          <p className="text">2. Swapnadeep</p>
          <div className="spacing"></div>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
        </div>
        <ColoredLine color="#54121E" />
        <br />
        <p className="text1">Score: 1197 points</p>
        <div></div>
      </div>
      <br />
      <div className="container1">
        <div className="container2">
          <p className="text">3. Rishi</p>
          <div className="spacing"></div>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
        </div>
        <ColoredLine color="#54121E" />
        <br />
        <p className="text1">Score: 1052 points</p>
        <div></div>
      </div>
      <br />
      <div className="container1">
        <div className="container2">
          <p className="text">4. Amita </p>
          <div className="spacing"></div>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
          <i style={{ fontSize: "24px" }} className="fa fa-star right text"></i>
        </div>
        <ColoredLine color="#54121E" />
        <br />
        <p className="text1">Score: 621 points</p>
        <div></div>
      </div>
      <br />
    </div>
  );
}
